// extracted by mini-css-extract-plugin
var _1 = "ewSA3YMM";
var _2 = "OI4TMFkO";
export { _1 as "l5", _2 as "loader" }
